import React from "react";
import { EsgDashBoardIcon } from "assets";

export const DASHBOARD_PAGE = {
  ABSOLUTE_PATH: "/dashboard",
  TITLE: "Dashboard",
  ICON: <EsgDashBoardIcon />,
  IS_TBD: false,
  renderMenu: false,
};



